var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"open-delay":"500","top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"outlined":"","color":"primary"}},'v-btn',attrs,false),on),[_c('span',[_vm._v("Open Delay On Hover")])])]}}])},[_c('span',[_vm._v("Open Delay On Hover")])])}
var staticRenderFns = []

export { render, staticRenderFns }